import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { DuvidaTecnicaController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IDuvidaTecnicaRequest } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/DuvidaTecnica/DuvidaTecnicaInterface";

interface IDuvidaTecnicaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function DuvidaTecnica(props: IDuvidaTecnicaProps) {
    const { updateAtendimento, ID_CASO } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: executarFormDuvidaTecnica, loading } = useAsyncCallback(
        DuvidaTecnicaController
    );

    const handleCriarDuvidaTecnicaSubmit = (
        formData: IDuvidaTecnicaRequest
    ) => {
        executarFormDuvidaTecnica(ID_CASO, { ...formData }).then(() => {
            updateAtendimento();
            ReloadHistorico();
            props.setShow(false);
        });
    };

    return (
        <UnForm handleSubmit={handleCriarDuvidaTecnicaSubmit}>
            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Textarea
                        registerOptions={{
                            required: "Insira sua Dúvida",
                        }}
                        //adaptar o name para nome certo
                        name="DsDuvidaTecnica"
                        label="Descrição"
                        noRezise
                        rows={4}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>
            <div className="mb-8">
                <div className="row m-0 d-flex justify-content-center ">
                    <UnForm.Switch
                        label="Marque para o cliente visualizar este histórico"
                        name="ClienteVisualizaHistorico"
                        color="success"
                        labelPosition="top"
                        type="checkbox"
                    />
                </div>
            </div>
            <UnForm.SubmitButton
                color="success"
                wrapperClassName="w-100 mt-8"
                className="w-100"
                icon={faQuestion}
                loading={loading}
                disabled={loading}
                loadingSize={"sm"}
            >
                Enviar Dúvida
            </UnForm.SubmitButton>
        </UnForm>
    );
}
